module.exports = __webpack_public_path__ + "static/images/vaccination.72f4739bcc5c92c9753a76a632344f7f.svg";